import React from 'react'
import PropTypes from 'prop-types'
import { RATING } from '../../constants/classifications'

export default class Review extends React.Component {
  render() {
    const {
      aspect, aspectLabel, value, showValueLabel, bestRating, worstRating, t
    } = this.props

    const RATING_KEYS = {
      最悪: "very_bad",
      悪い: "bad",
      まあまあ: "good",
      とても良い: "very_good",
      すばらしい: "exellent"
    }
    var key = RATING_KEYS[RATING[value]]

    return (
      <div className={`rating rating-${value} ${aspect ? `rating-${aspect}` : ''}`} itemProp="reviewRating" itemScope itemType="http://schema.org/Rating">
        <meta itemProp="worstRating" content={worstRating} />
        <meta itemProp="bestRating" content={bestRating} />
        { aspect && <meta itemProp="reviewAspect" content={aspect} /> }
        <meta itemProp="ratingValue" content={value} />
        { showValueLabel && <div className="value">{t('users.edit.review.' + key)}</div> }
        <div className="indicator">
          { [...Array(value)].map((e, i) => <span className="star star-filled" key={i}></span>) }
          { [...Array(bestRating - value)].map((e, i) => <span className="star star-placeholder" key={i}></span>) }
          { aspectLabel && <span className="label">{aspectLabel}</span> }
        </div>
      </div>
    )
  }

  static propTypes = {
    aspect: PropTypes.string,
    aspectLabel: PropTypes.string,
    value: PropTypes.number.isRequired,
    showValueLabel: PropTypes.bool,
    bestRating: PropTypes.number,
    worstRating: PropTypes.number
  }

  static defaultProps = {
    aspect: '',
    aspectLabel: '',
    showValueLabel: false,
    bestRating: 5,
    worstRating: 1
  }
}
